/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Options from './Options/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/Employers/EmployerItem/Employer/Content",
  onChangeFilter
  
}) {
let employersValueData = fromData.useDataValue({ viewPath,
context: 'employers',
})
let selectedSearchValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'search',
})
let employersValueData1 = fromData.useDataValue({ viewPath,
context: 'employers',
})
let employerIdValueData = fromData.useDataValue({ viewPath,
context: 'employer',
path: 'id',
})
let aggregateData = fromHelpers.getValue(employersValueData1, employerIdValueData)
let employerNameValueData = fromData.useDataValue({ viewPath,
context: 'employer',
path: 'name',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  onChangeFilter
  
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="employers"
 from={employersValueData}
 data="selected.search"
 valueFilter={selectedSearchValueData}
 onChangeFilter={onChangeFilter}
 data="employers"
 data="employer.id"
 aggregate="helpers.js getValue"
 value={aggregateData}
 data="employer.name"
 selectedPlaceholder={employerNameValueData}
 onChange={onChange}
 maxWidth="50%"
 optionsWidth={390}
 keepFilter={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelectOneLabel
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Employer"
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
</div>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}